import React from 'react'
import { connect } from 'react-redux'
import TitleBar from '../components/TitleBar'
import Receipt from '../components/Receipt'
import Keyboard from '../components/Keyboard'
import Menu from '../objectmanagement/components/Menu'
import FunctionBar from '../components/FunctionBar'
import ObjectItemOverview from '../objectmanagement/components/ObjectItemOverview'
import MessageBar from '../objectmanagement/components/MessageBar'

class ObjectManagementPage extends React.Component {

    render() {
        
        return (
            <div id="app">
                <div id="main-container">
                    <TitleBar />
                    <MessageBar />
                    <ObjectItemOverview />
                    <Menu />
                    <FunctionBar cssClass="om_functionbar" />
                </div>
                <div id="receipt-keyboard-container">
                    <Receipt />
                    <Keyboard />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        objectgroups: state.objectManagementState.objectgroups,
        selectedobjectgroup: state.objectManagementState.selectedobjectgroup
    }
}

export default connect(mapStateToProps)(ObjectManagementPage)



// WEBPACK FOOTER //
// src/pages/ObjectManagementPage.jsx